export default "__VITE_ASSET__CixEoZEX__"